import axios from 'axios';

import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  }
});

export const taskService = {
  /** Every employee's assignments on one day (`date` = YYYY-MM-DD), with employee + project. */
  getDailyAssignments: async (date: string) => {
    const res = await api.get('/admin/assignments/daily', { params: { date } });
    if (res.data.status === 'success') {
      return res.data.data;
    }
    throw new Error(res.data.message || 'Failed to fetch assignments');
  },

  getMonthlyAssignments: async (employeeId: string, month: number, year: number) => {
    const res = await api.get(`/admin/employees/${employeeId}/monthly-assignments`, {
      params: { month, year },
    });
    if (res.data.status === 'success') {
      return res.data.data;
    }
    throw new Error(res.data.message || 'Failed to fetch assignments');
  },

  assignEmployeeCalendar: async (projectId: string, payload: any) => {
    const res = await api.post(`/admin/projects/${projectId}/assign-employee-calendar`, payload);
    if (res.data.status === 'success') {
      return res.data.data;
    }
    throw new Error(res.data.message || 'Failed to assign employee');
  },

  deleteAssignment: async (assignmentId: number) => {
    const res = await api.delete(`/admin/projects/assignments/${assignmentId}`);
    if (res.data.status === 'success') {
      return res.data;
    }
    throw new Error(res.data.message || 'Failed to delete assignment');
  },

  updateAssignmentProject: async (assignmentId: number, projectId: number) => {
    const res = await api.put(`/admin/projects/assignments/${assignmentId}/update-project`, {
      project_id: projectId
    });
    if (res.data.status === 'success') {
      return res.data.data;
    }
    throw new Error(res.data.message || 'Failed to update assignment');
  }
};
